
export enum CustomerRequestPriorityCd {
	NONE = 'None',
	REQD_BILLING = 'ReqdBilling',
	RFP_PENDING = 'RfpPending'}
